import { createMergedTheme } from '@timmons-group/shared-react-components';

const darkBlue = '#1F4765';
const lightGray = '#C8C8C8';

const cppThemeProperties = {
  communityChip: {
    backgroundColor: '#CCE0FF',
  },
  communityShapeBox: {
    border: '1px solid #C4C4C4',
    borderRadius: '4px',
    padding: '8px',
    margin: '5px 0px',
  },
  communityMap: {
    position: 'relative',
    marginTop: '16px',
    paddingLeft: {
      xs: '16px',
      lg: '7.8%',
    },
    paddingRight: {
      xs: '16px',
      lg: '7.8%',
    },
  },
  flexCard: {
    border: `2px solid ${lightGray}`,
    boxShadow: 'none',
    borderRadius: '4px',
    marginBottom: '10px',
    marginTop: '15px',
  },
  inspector: {
    featuredCard: {
      heading: { fontFamily: 'sans-serif', fontWeight:'bold', fontSize: '14px', color: darkBlue, marginTop: '10px' },
      legend: { fontFamily: 'sans-serif', fontWeight:'bold', fontSize: '32px', marginBottom: '20px' },
    }
  },
  palette: {
    //insert new colors here
  },
  typography: {
    fontFamily: ['"PT Sans"', 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          // add new variants here
        },
      },
    },
  },
};

const theTheme = createMergedTheme(cppThemeProperties);

export default theTheme;
